module.exports = __webpack_public_path__ + "media/icons/addition-05031c71.png";